import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from '@mui/material';
import {SoftAlert} from 'components/soft/SoftUI';
import {SOFT} from 'components/soft/softTheme';
import {ReactNode} from 'react';

/** Confirm dialog for pair power, reboot and delete. destructive = red button. */
export default function HAConfirmDialog(props: {
	open: boolean;
	title: string;
	body: ReactNode;
	confirm: string;
	destructive?: boolean;
	busy?: boolean;
	error?: string | null;
	onConfirm: () => void;
	onClose: () => void;
}) {
	const {open, title, body, confirm, destructive, busy, error, onConfirm, onClose} = props;
	return (
		<Dialog open={open} onClose={busy ? undefined : onClose} aria-labelledby="ha-confirm-title" maxWidth="sm">
			<DialogTitle id="ha-confirm-title">{title}</DialogTitle>
			<DialogContent>
				<Typography data-testid="ha-confirm-body" sx={{fontSize: 14, color: SOFT.color.text}}>
					{body}
				</Typography>
				{error && (
					<SoftAlert severity="error" sx={{mt: 2}} data-testid="ha-confirm-error">
						{error}
					</SoftAlert>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} disabled={busy}>
					Cancel
				</Button>
				<Button
					data-testid="ha-confirm-button"
					data-destructive={destructive ? 'true' : 'false'}
					variant="contained"
					color={destructive ? 'error' : 'primary'}
					onClick={onConfirm}
					disabled={busy}
				>
					{confirm}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
